'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClassCancellationModal = exports.ClassCancellationModalUnwrapped = exports.mapDispatchToProps = exports.mapStateToProps = exports.modalConfig = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _cancellationTypes = require('constants/cancellation-types');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _bound = require('redux/saga/entities/bound');

var _modals = require('redux/modules/modals');

var _Pending = require('components/Profile/Pending');

var _TimeRange = require('components/TimeRange/TimeRange');

var _time = require('helpers/time');

var _profile = require('./profile.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modalConfig = exports.modalConfig = {
  headerClass: 'modal--class-cancellation',
  lightClose: true
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    cancelReservationEntity: _bound.cancelReservationEntity.select(state, ownProps.id)
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  cancelReservation: _profile.cancelReservation,
  hideModal: _modals.hideModal
};

var CANCEL_POLICY_HREF = 'https://help.classpass.com/hc/articles/207942743-What-is-the-class-cancellation-policy-';

var ClassCancellationModalUnwrapped = exports.ClassCancellationModalUnwrapped = function (_React$Component) {
  (0, _inherits3.default)(ClassCancellationModalUnwrapped, _React$Component);

  function ClassCancellationModalUnwrapped(props) {
    (0, _classCallCheck3.default)(this, ClassCancellationModalUnwrapped);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ClassCancellationModalUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ClassCancellationModalUnwrapped)).call(this, props));

    _this.state = {
      understood: !props.late
    };

    _this.areYouSureMessaging = _this.areYouSureMessaging.bind(_this);
    _this.confirmationMessaging = _this.confirmationMessaging.bind(_this);
    _this.iUnderstandMessaging = _this.iUnderstandMessaging.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ClassCancellationModalUnwrapped, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.late !== this.props.late && !nextProps.late !== this.state.understood) {
        this.setState({
          understood: !nextProps.late
        });
      }
    }
  }, {
    key: 'handleAgreeChange',
    value: function handleAgreeChange() {
      this.setState({
        understood: !this.state.understood
      });
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit() {
      var _props = this.props,
          userId = _props.userId,
          id = _props.id;

      if (this.state.understood) {
        this.props.cancelReservation(userId, id);
      }
    }
  }, {
    key: 'iUnderstandMessaging',
    value: function iUnderstandMessaging() {
      var cancellationPolicy = this.props.cancellationPolicy;


      if (cancellationPolicy === _cancellationTypes.CANCELLATION_FLYWHEEL) {
        return _react2.default.createElement(
          'label',
          { htmlFor: 'understand', className: 'inline-block' },
          'I understand that Flywheel/FlyBarre reservations must be canceled by 5pm the night before class, so canceling now will result in a ',
          _react2.default.createElement(
            'a',
            { href: CANCEL_POLICY_HREF, target: 'help' },
            'fee'
          ),
          '.'
        );
      }

      return _react2.default.createElement(
        'label',
        { htmlFor: 'understand', className: 'inline-block' },
        'I understand that this class starts within 12 hours and canceling will incur a late cancellation ',
        _react2.default.createElement(
          'a',
          { href: CANCEL_POLICY_HREF, target: 'help' },
          'fee'
        ),
        '.'
      );
    }
  }, {
    key: 'areYouSureMessaging',
    value: function areYouSureMessaging() {
      var _props2 = this.props,
          name = _props2.name,
          studio = _props2.studio,
          startTimestamp = _props2.startTimestamp,
          endTimestamp = _props2.endTimestamp,
          image = _props2.image,
          late = _props2.late,
          credits = _props2.credits;


      return [_react2.default.createElement('div', { className: 'modal__header modal__header__img pv++', style: { backgroundImage: 'url("' + image + '")' } }), _react2.default.createElement(
        'div',
        { className: 'modal__content text--center' },
        _react2.default.createElement(
          'div',
          { className: 'modal__main' },
          _react2.default.createElement(
            'div',
            { className: 'group_container clearfix pv' },
            _react2.default.createElement(
              'div',
              { className: 'mv' },
              _react2.default.createElement(
                'p',
                null,
                name
              ),
              _react2.default.createElement(
                'p',
                null,
                studio
              )
            ),
            _react2.default.createElement(
              'h3',
              { className: 'text--xl' },
              _react2.default.createElement(_reactIntl.FormattedDate, {
                value: (0, _time.parseUnixSecondsDate)(startTimestamp),
                weekday: 'long',
                month: 'long',
                day: 'numeric'
              }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_TimeRange.TimeRange, {
                  startTimestamp: startTimestamp,
                  endTimestamp: endTimestamp
                })
              )
            ),
            credits !== undefined && _react2.default.createElement(
              'div',
              { className: 'mb-' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'classCancellation.upcomingItem.credits',
                defaultMessage: '{creditsWrappedInHtml} {creditsAsInteger, plural, one {credit} other {credits}}',
                values: {
                  creditsAsInteger: credits,
                  creditsWrappedInHtml: _react2.default.createElement(
                    'span',
                    { className: 'block delta' },
                    credits
                  )
                }
              })
            )
          )
        ),
        late && _react2.default.createElement(
          'div',
          { className: 'modal__details-check' },
          _react2.default.createElement('input', { type: 'checkbox', onChange: this.handleAgreeChange.bind(this), className: 'inline-block', id: 'understand', name: 'understand' }),
          this.iUnderstandMessaging()
        ),
        _react2.default.createElement(
          'button',
          { className: 'bt bt--danger bt--lg bt--width-lg mb-', onClick: this.handleSubmit.bind(this), disabled: !this.state.understood },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'modal.cancellation.submit',
            defaultMessage: 'Cancel this class'
          })
        ),
        credits > 0 && _react2.default.createElement(
          'p',
          { className: 'text--sm text--center mt' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'modal.note.credits.refund',
            defaultMessage: 'We\'ll refund your {creditsAmount}',
            values: {
              creditsAmount: _react2.default.createElement(
                'span',
                { className: 'text--bold' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'modal.note.credits.amount',
                  defaultMessage: '{creditsCount} {creditsCount, plural, one {credit} other {credits}}',
                  values: {
                    creditsCount: credits
                  }
                })
              )
            }
          })
        )
      )];
    }
  }, {
    key: 'confirmationMessaging',
    value: function confirmationMessaging() {
      var _props3 = this.props,
          localCancelReservationEntity = _props3.cancelReservationEntity,
          studio = _props3.studio,
          localHideModal = _props3.hideModal;


      return _react2.default.createElement(
        'div',
        { className: 'modal__content' },
        _react2.default.createElement(
          'div',
          { className: 'modal__body' },
          _react2.default.createElement(
            'div',
            { className: 'modal__confirmation-message' },
            !localCancelReservationEntity.error ? 'Reservation cancelled' : 'Cancellation failed'
          ),
          _react2.default.createElement(
            'div',
            { className: 'delta mv-' },
            studio
          ),
          !localCancelReservationEntity.error ? _react2.default.createElement(
            'p',
            { className: 'mb' },
            'Your reservation has been cancelled successfully.'
          ) : _react2.default.createElement(
            'p',
            { className: 'mb' },
            'Your reservation could not be cancelled at this time.',
            _react2.default.createElement('br', null),
            'Please try again later.'
          ),
          _react2.default.createElement(
            'button',
            { className: 'bt bt--primary bt--lg mb-', onClick: localHideModal.bind(this, 'ClassCancellationModal') },
            'Done'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          localCancelReservationEntity = _props4.cancelReservationEntity,
          id = _props4.id,
          source = _props4.source;


      var cancellation = localCancelReservationEntity;
      var alreadyCancelled = cancellation && cancellation.data && cancellation.data.id === id;

      return _react2.default.createElement(
        'div',
        { className: 'modal__cancellation' },
        !cancellation.loading && !cancellation.loaded && !cancellation.error && !alreadyCancelled && this.areYouSureMessaging(),
        cancellation.loading && _react2.default.createElement(
          _Pending.Pending,
          null,
          _react2.default.createElement(_Pending.Pending.CancelReservation, null)
        ),
        !cancellation.loading && (cancellation.loaded || cancellation.error) && this.confirmationMessaging(),
        !cancellation.loading && source === 'MINDBODYAPI' && _react2.default.createElement(
          'a',
          { href: 'https://www.mindbodyonline.com/', target: '_blank', rel: 'noopener noreferrer', className: 'modal__powered-by' },
          _react2.default.createElement('img', { src: '/img/mindbody-powered-logo.png', alt: 'Powered by MindBody', width: '140', height: '43' })
        )
      );
    }
  }]);
  return ClassCancellationModalUnwrapped;
}(_react2.default.Component);

ClassCancellationModalUnwrapped.propTypes = {
  id: _propTypes2.default.number.isRequired,
  name: _propTypes2.default.string.isRequired,
  studio: _propTypes2.default.string.isRequired,
  startTimestamp: _propTypes2.default.number.isRequired,
  endTimestamp: _propTypes2.default.number.isRequired,
  image: _propTypes2.default.string.isRequired,
  late: _propTypes2.default.bool,
  source: _propTypes2.default.string.isRequired,
  cancelReservation: _propTypes2.default.func.isRequired,
  cancelReservationEntity: _propTypes2.default.object.isRequired,
  userId: _propTypes2.default.number.isRequired,
  hideModal: _propTypes2.default.func.isRequired,
  cancellationPolicy: _propTypes2.default.string.isRequired,
  credits: _propTypes2.default.number
};

var ClassCancellationModal = exports.ClassCancellationModal = (0, _Modal2.default)(modalConfig)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ClassCancellationModalUnwrapped));